// import { cloneDeep } from 'lodash';

// const initialState = {
//   authenticated: false,
//   user: {
//     userId: null,
//     alias: null,
//     role: null,
//     placeId: null,
//   },
//   placeId: 'friendspub',
//   loading: false,
// };

const login = (state, payload) => {
  const { user: { userId, alias, role, placeId } } = payload;
  const newState = {
    authenticated: true,
    user: {
      userId,
      alias,
      role,
      placeId,
    },
    loading: false,
  };
  
  return newState;
};

export { login };
